module.exports = __webpack_public_path__ + "static/media/tick.4c61ad13.svg";